import { Outlet } from "react-router-dom";
import MeshBackground from "./MeshBackground";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="shell">
      <MeshBackground />
      <Navbar />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
